export function observePaywallVisibility(
  element: Element,
  onVisible: () => void,
) {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          obs.disconnect();
          onVisible();
        }
      }
    },
    {
      threshold: 0.5,
    },
  );

  observer.observe(element);

  return observer;
}

export function appendTrackingParamsToLinks(
  container: HTMLElement,
  trackingParams: string,
) {
  const links = container.querySelectorAll<HTMLAnchorElement | HTMLElement>(
    "a, ws-link",
  );

  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (
      !href ||
      href.includes("contentId") ||
      href.includes("contentUrl") ||
      href.includes("wdycf")
    ) {
      return;
    }

    const newHref = href.includes("?")
      ? `${href}&${trackingParams}`
      : `${href}?${trackingParams}`;

    link.setAttribute("href", newHref);
  });
}

export function findCheckoutLink(container: Element): HTMLElement | undefined {
  const links = container.querySelectorAll("a, ws-link");
  return Array.from(links).find(
    (elm): elm is HTMLElement =>
      elm instanceof HTMLElement &&
      elm.hasAttribute("href") &&
      elm.getAttribute("href")!.includes("p-user/checkout"),
  );
}
